<div class="widget">
  <div class="widget-background" *ngIf="settings.imageLocation" [style.background-image]="'url(' + settings.imageLocation + ')'"></div>
  <div
    class="widget-content"
    [style.height]="settings.imageLocation ? 'calc(100% - 182px)' : '100%'"
    [ngClass]="{'button-available': settings.buttonText && settings.buttonUrl && (settings.buttonType === 'hyperlink' || settings.buttonType === 'video')}"
  >
    <span class="title">{{ settings.title }}</span>
    <p>{{ settings.description }}</p>
    <a class="button button-secondary" [href]="settings.buttonUrl" target="_blank" *ngIf="settings.buttonText && settings.buttonUrl && settings.buttonType === 'hyperlink'">
      {{ settings.buttonText }}
    </a>
    <button class="button button-secondary" (click)="openVideo()" *ngIf="settings.buttonText && settings.buttonUrl && settings.buttonType === 'video'">         
      {{ settings.buttonText }}
    </button>
  </div>
</div>